export const formatDateTime = (time) => {
    const localTime = new Date(time).toLocaleTimeString();
    const localDate = new Date(time).toLocaleDateString();
    return localDate + " " + localTime;
};
